<template>
  <div class="notice-list">
    <associationNotice @changePage="changePage" @click="toDetails" :list="notice" :total="noticeTotal" v-loading="loading"></associationNotice>
  </div>
</template>

<script>
import associationNotice from '@/components/associationNotice.vue'
import {mapMutations} from 'vuex'
import {findRoute} from '@/utils/routerHelper.js'
import {dynamics} from '@/api/api.js';
export default {
  components:{
    associationNotice
  },
  data(){
    return {
      loading:false,
      notice:[
        // {
        //   title:'党建引领社会工作发展专题研讨会顺利召开',
        //   date:'2025-12-15',
        // },
        // {
        //   title:'党建引领下的社区治理创新实践分享会',
        //   date:'2025-12-10',
        // },
        // {
        //   title:'党建引领社会组织发展论坛成功举办',
        //   date:'2025-12-05',
        // },
        // {
        //   title:'党建引领社会工作服务体系建设推进会',
        //   date:'2025-12-01',
        // },
        // {
        //   title:'党建引领下的社会工作专业人才培养',
        //   date:'2025-11-28',
        // },
        // {
        //   title:'党建引领社区志愿服务工作交流会',
        //   date:'2025-11-25',
        // },
        // {
        //   title:'党建引领社会工作创新案例征集活动启动',
        //   date:'2025-11-20',
        // },
        // {
        //   title:'党建引领社会工作标准化建设工作研讨会',
        //   date:'2025-11-15',
        // },
      ],
      noticeTotal:0,
      currentPage:1
    }
  },
   created(){
    this.getList()
  },
  methods:{
    ...mapMutations('routerData',['changeRouterList']),
    getList(){
      dynamics({
        current:this.currentPage,
        size:10,
        type:13
      }).then(res=>{
        if(res.data.code==200){
          this.noticeTotal=res.data.data.total
          this.notice=res.data.data.records.map(v=>{
            let dateData=this.getDate(v.createTime)
            v.date=dateData.newDates,
            v.day=dateData.day
            return v
          })
        }
      })
    },
    toDetails(data){
      this.$router.push(
        { path: '/associationNews/details',query: { id: data.id } }
      )

      let routerList=[]
      let routers = ['/specialColumn','specialColumnPartyBuilding', '/associationNews/details'];
      for (let i = 0; i < routers.length; i++) {
        let routerData=findRoute(this.$router.options.routes, routers[i])
         routerList.push(routerData)
      }
      this.changeRouterList(routerList)
    },
    changePage(page){
      this.currentPage=page
      this.getInfo()
    },
    getDate(dateString){
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      return {
        day,
        newDates:year+'-'+(month<10?('0'+month):month)
      }
    },
  }
}
</script>

<style lang="less" scoped>
.notice-list {
  width: 100%;
}
</style>
